<template lang="pug" id="app">
  b-container(fluid)
    b-card
      template(#header)
        b-row.align-items-center
          b-col(cols="4")
            b-form-file(@change="readFile", accept=".xlsx")
          b-col
            b-button(size="sm", @click="submitData") {{ $t('enrollment') }}
            b-button.ml-3(size="sm", variant="primary", :href="excelFormUrl", download) {{ $t('excel-form') }}
      
      b-table(:items="items", :fields="fields", responsive, striped, hover, bordered, :empty-text="$t('no-content')",)
        template(#cell(selected)="row")
          b-form-checkbox(v-model="row.item.selected")
      
      template(#footer)
        b-pagination(
          v-model="page.current",
          :total-rows="page.total",
          :per-page="page.per",
          size="sm",
          align="right"
        )
</template>


<script>
import Switches from 'vue-switches'
import {UserExcelUploadAPI} from '../../api'
import XLSX from 'xlsx'
import store from '@/api/store'


export default {
  name: 'excel-add-manager-component',
  components: {Switches},
  data() {
    return {
      items: [],
      fields: [
        {key: 'selected', label: '', thStyle: {width: '40px'}},
        {key: 'mgrid', label: this.$t('ID')},
        {key: 'pw', label: this.$t('PW')},
        {key: 'name', label: this.$t('name')},
        {key: 'email', label: this.$t('Email')},
        {key: 'phone', label: this.$t('phone')},
        {key: 'department', label: this.$t('department')},
        {key: 'position', label: this.$t('cowork_position')},
        {key: 'group_name', label: this.$t('group')},
      ],
      page: {
        current: 1,
        per: 10,
        total: 0,
      },
      lang: this.$i18n.locale || 'ko',
    }
  },
  mounted() {
    this.getSummary()
  },
  computed: {
    excelFormUrl() {
      return `/static/form/linkmemine_user_form_${this.lang}.xlsx`
    },
  },
  methods: {
    readFile(event) {
      const file = event.target.files[0]
      if (!file) {
        return
      }
      
      const reader = new FileReader()
      reader.onload = (e) => {
        const wb = XLSX.read(e.target.result, {type: 'array'})
        const rows = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], {defval: ''})
        
        this.items = rows.map((row, idx) => {
          const id = row['ID'] || row['id'] || Object.values(row)[0]
          const pw = row['PW'] || row['pw'] || Object.values(row)[1]
          const name = row['Name'] || row['name'] || Object.values(row)[2]
          
          const isValidId = /^[a-zA-Z0-9@._-]{4,38}$/.test(id)
          const isValidName = name && name.trim() !== ''
          
          if (isValidId && isValidName) {
            return {
              selected: true,
              mgrid: id,
              pw: pw,
              name: name,
              email: row['Email'] || '',
              phone: row['Phone'] || '',
              department: row['Department'] || '',
              position: row['Position'] || '',
              group_name: row['Group'] || '',
            }
          }
          return null
        }).filter(Boolean)
        this.page.total = this.items.length
      }
      
      reader.readAsArrayBuffer(file)
    },
    submitData() {
      const selected = this.items.filter(item => item.selected)
      if (selected.length === 0) {
        this.$awn.warning(this.$t('no-selected'))
        return
      }
      
      UserExcelUploadAPI.post('', JSON.stringify(selected))
          .then((res) => {
            const {total, failure} = res.data.objects
            this.$awn.success(this.$t('excel_user_submit', {total, failure}))
            this.$router.push({name: 'managers'})
          })
          .catch((err) => {
            console.error(err)
            this.$awn.alert('업로드 실패')
          })
    },
    getSummary() {
      let stored = store.get('lang')
      this.lang = stored
    },
  },
}

</script>

<style scoped>
th, td {
  text-align: left;
  vertical-align: middle;
}

.table-responsive {
  margin: 0;
}
</style>